import type { Directive, DirectiveBinding } from 'vue';

const debounceClick: Directive = {
    inserted(el: HTMLElement, binding: DirectiveBinding<number>) {
        let timer = 0;
        const delay = binding.value ?? 1000;
        el.addEventListener('click', () => {
            el.style.pointerEvents = 'none';
            clearTimeout(timer);
            timer = setTimeout(() => {
                el.style.pointerEvents = 'auto';
            }, delay);
        });
    },
};

export default debounceClick;
